export default {
    USER_ID: `user_9VEo69Fy4geiePQvUueyN`, //userID
    TEMPLATE_ID: `template_7o1c1wm`,         //templateID
    SERVICE_ID: `service_2aqt2w91`
}